import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.List.IRequest;
type Response = Api.Core.Claim.List.IResponse;
type Headers = Api.Core.Claim.List.IHeaders;
const url = '/api/Claims/Claim';
export default async function claimListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
